/* RESPONSIBLE TEAM: team-inbox-experience */
import { inject as service } from '@ember/service';
import type Session from 'embercom/services/session';
import { SimpleAction } from 'embercom/objects/inbox/command-k/action';

export default class SetDarkTheme extends SimpleAction {
  @service declare session: Session;

  id = 'set-dark-theme';
  icon = 'theme' as const;

  get label() {
    return this.intl.t('inbox.switch-dark-mode');
  }
}
